import SelectPathPage from "./SelectPathPage";


const loginData = [
  {
    heading: "Student / Parent",
    description: "I’m ready to begin my journey as a Student",
    icon: "icons8:student",
    iconColor: "#C60202",
    bgColor: "#FFEAEA",
    path: "/StudentLogin",
  },
  {
     heading: "Trainer",
    description: "I’m here to guide and train learners",
    icon: "ph:chalkboard-teacher",
    iconColor: "#0404B4",
    bgColor: "#E2E2FF",
    path: "/TrainerLogin",
  },
  {
    heading: "Apartment",
    description: "I would like to join as an Apartment",
    icon: "material-symbols-light:apartment",
    iconColor: "#A10069",
    bgColor: "#FFD4F0",
    path: "/ApartmentLogin",
  },
  {
    heading: "Employee",
    description: "I’m ready to manage and grow with the organization",
    icon: "mdi:briefcase-account",
    iconColor: "#0258C6", 
    bgColor: "#EAF0FF",
    path: "/EmployeeLogin",
  },

  {
    heading: "School",
    description: "I would like to join as School",
    icon: "ep:school",
    iconColor: "#990066",
    bgColor: "#FFF3D4",
    path: "/login",
  },


  {
    heading: "Teacher",
    description: "I would like to join as Teacher",
    icon: "la:chalkboard-teacher",
    iconColor: "#006699", // deep teal-blue (trust, knowledge)
    bgColor: "#E6F7FF",   // very light sky blue shade

    path: "/TeacherLogin",
  },

  // {
  //   heading: "Publisher",
  //   description: "I would like to join as Publisher",
  //   icon: "fluent-mdl2:publish-course",
  //   iconColor: "#4B0082",
  //   bgColor: "#EDE7F6",
  //   path: "/PublisherLogin",
  // },




];

const SelectLoginPath = () => {
  return (
    <SelectPathPage
      title="Please Choose Your Role to Begin."
      description="To make sure we give you the best experience, kindly select the role that suits you best"
      data={loginData}
      bottomText="If you don't have an account !!"
      bottomLinkText="Sign Up"
      bottomLinkPath="/SelectSignupPath"
      clearSession={true}
    />
  );
};

export default SelectLoginPath;
